import React, { useEffect } from "react";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Paper,
  TextField,
} from "@mui/material";

export default function CustomListOptions({ formData, setFormData }) {
  // Ensure descriptions exist for all checked items
  useEffect(() => {
    const newDescriptions = [...formData.custom_field_description];

    Object.keys(formData.custom_list).forEach((field) => {
      const isChecked = formData.custom_list[field];
      const alreadyExists = newDescriptions.some(
        (item) => item.custom_field_column_name === field
      );

      if (isChecked && !alreadyExists) {
        newDescriptions.push({
          custom_field_column_name: field,
          custom_field_filter_contain: "",
        });
      }
    });

    if (newDescriptions.length !== formData.custom_field_description.length) {
      setFormData((prev) => ({
        ...prev,
        custom_field_description: newDescriptions,
      }));
    }
  }, [formData.custom_list, formData.custom_field_description, setFormData]);

  const handleCheckboxChange = (field) => {
    setFormData((prev) => {
      const updatedCustomList = {
        ...prev.custom_list,
        [field]: !prev.custom_list[field],
      };

      let updatedCustomDesc = [...prev.custom_field_description];

      if (!updatedCustomList[field]) {
        updatedCustomDesc = updatedCustomDesc.filter(
          (item) => item.custom_field_column_name !== field
        );
      }

      return {
        ...prev,
        custom_list: updatedCustomList,
        custom_field_description: updatedCustomDesc,
      };
    });
  };

  const handleDescriptionChange = (field, value) => {
    setFormData((prev) => {
      const updatedDescriptions = prev.custom_field_description.map((desc) =>
        desc.custom_field_column_name === field
          ? { ...desc, custom_field_filter_contain: value }
          : desc
      );

      return {
        ...prev,
        custom_field_description: updatedDescriptions,
      };
    });
  };
console.log("formdata***", formData);
  return (
    <Paper elevation={3} sx={{ p: 3, mx: "auto", mt: 4, borderRadius: 2 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        Custom List Options
      </Typography>

      <Grid container spacing={2}>
        {Object.keys(formData.custom_list).map((field) => {
          const isChecked = formData.custom_list[field];

          const descObj = formData.custom_field_description && formData.custom_field_description.find(
            (item) => item.custom_field_column_name === field
          );

          return (
            <Grid item xs={12} sm={6} md={4} key={field}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={() => handleCheckboxChange(field)}
                  />
                }
                label={field
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())}
                sx={{
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.1)",
                }}
              />

              {isChecked && descObj && (
                <TextField
                  label="Enter filter values (comma-separated)"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={descObj.custom_field_filter_contain}
                  onChange={(e) =>
                    handleDescriptionChange(field, e.target.value)
                  }
                  sx={{ mt: 1 }}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
}
